import React, { useState, useEffect, useCallback } from "react";
import UserService from "../services/user.service";
import SubSiteService from "../services/catalog.service";
import AuthService from "../services/auth.service";
import Navbar from "react-bootstrap/Navbar";
import ProductMenu from "./ProductMenu";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { green } from "../util/themes";
import { red } from "../util/themes";
import { PersonCircle, Cart, Search, Pencil } from 'react-bootstrap-icons';
import { selectAllMenuItems, getMenu } from '../reducers/menu'
import Spinner from "react-bootstrap/Spinner";
import { cart, cartCount, showCart, toggleShowCart, removeItemFromOrder } from '../reducers/cart';
import { isLoggedIn, isAdmin, getUser, logout, getSubsite } from '../reducers/auth';
import { searchCatalog } from '../reducers/catalog';
import SwitchSiteModal from './modals/SwitchSiteModal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import Dropdown from "react-bootstrap/Dropdown";
import styled from 'styled-components';

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;


const FakeNavBar = (props) => {
    const currentSubsite = useSelector(getSubsite);
  
    const StyledDiv = styled.div`
    &:hover {
      color: ${props.menuTextHoverColor ? props.menuTextHoverColor : "inherited"};
      // Add other hover styles as needed
    }
  `;

    return (
        <>
            <Navbar expand="lg" data-bs-theme={props.lightTheme ? "light" : "dark"} style={{ backgroundColor: props.topNavBgColor ? props.topNavBgColor : "#000000" }}>
                <Container fluid>
                    <Navbar.Toggle variant={props.lightTheme ? "light" : "dark"} />
                    <Navbar.Brand >
                        <Image className="navbar-brand" src="/logo.png" alt="Logo" fluid />
                    </Navbar.Brand>
                    <Navbar.Text style={{ border: "1px solid ", padding: 10, borderRadius: 5 }} >
                        You are shopping on: <br />
                        Shop Ignite
                    </Navbar.Text>
                    <Navbar.Collapse className="justify-content-end" data-bs-theme={props.lightTheme ? "light" : "dark"}>
                        <Container fliud style={{ flexDirection: "column" }}>
                            <Row style={{ alignItems: "flex-end" }}>
                                <Col xs={12} sm={12} md={4} style={{ alignSelf: "center" }}>
                                    <Form noValidate>
                                        <Form.Group className="nav-form" controlId="formBasicEmail">
                                            <Form.Control type="text" placeholder="Search" name="searchTerm" />
                                            <Button variant="secondary">
                                                <Search />
                                            </Button>
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xs={12} sm={12} md={8} style={{ alignSelf: "center" }}>
                                    <Container fluid style={{ alignItems: "flex-end" }}>
                                        <Row className="justify-content-end">
                                            <Col sm="auto" style={{ alignSelf: "center" }}>
                                                <Dropdown style={{ paddingRight: 5, marginTop: 4 }}>
                                                    <Dropdown.Toggle variant={props.lightTheme ? "light" : "dark"} id="dropdown-basic">
                                                        <PersonCircle size={18} /> Ignite
                                                    </Dropdown.Toggle>
                                                </Dropdown>
                                            </Col>
                                            <Col sm="auto" style={{ alignSelf: "center" }}>
                                                <div data-bs-theme={props.lightTheme ? "light" : "dark"} className="navbar-text" style={{ width: 60, marginTop: 4, marginRight: 10, paddingRight: 4, paddingLeft: 4, borderRadius: 2, border:"1px solid" }}>
                                                    <Navbar.Text><Cart /><span className="navbar-text">Cart</span> <br /></Navbar.Text>
                                                    <Badge variant={props.lightTheme} style={{ width: "100%" }}>2</Badge>
                                                </div>
                                            </Col>
                                            <Col sm="auto" style={{ alignSelf: "center" }}>
                                                {currentSubsite.logoFilename && (
                                                    <Image fluid style={{ height: 70 }} src={`${BACKEND_URL}/uploads/subsites/${currentSubsite.logoFilename}`} />
                                                )}
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                        </Container>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Container style={{ backgroundColor: props.menuBgColor ? props.menuBgColor : "#414141", alignContent: "center", textAlign: "center", marginLeft: "auto", marginRight: "auto" }} fluid>
                <Container fluid className="align-items-center darka" style={{ backgroundColor: props.menuBgColor ? props.menuBgColor : "#414141", alignItems: "center", alignContent: "center", textAlign: "center", marginLeft: "auto", marginRight: "auto" }}>
                    <Row className="justify-content-center" fluid style={{color: props.menuTextColor ? props.menuTextColor : "#FFFFFF"}}>
                        <Col style={{ padding: 2, alignContent: "center", textAlign: "center"}} xs="auto">
                            <Nav.Link style={{ fontSize: 16, color: props.menuTextColor ? props.menuTextColor : "#FFFFFF" }} activeClassName="activeMenu" >
                                <StyledDiv>Polos</StyledDiv>
                            </Nav.Link>
                        </Col>
                        <Col style={{ padding: 2, alignContent: "center", textAlign: "center" }} xs="auto">
                            <Nav.Link style={{ "&:hover": {color:"#FF0000"}, fontSize: 16, color: props.menuTextColor ? props.menuTextColor : "#FFFFFF" }} activeClassName="activeMenu">
                            <StyledDiv>Outerwear</StyledDiv>
                            </Nav.Link>
                            </Col>
                        <Col style={{ padding: 2, alignContent: "center", textAlign: "center" }} xs="auto">
                            <Nav.Link style={{ fontSize: 16, color: props.menuTextColor ? props.menuTextColor : "#FFFFFF" }} activeClassName="activeMenu">
                            <StyledDiv>Sweatshirts / Fleece</StyledDiv>
                            </Nav.Link>
                        </Col>
                    </Row>
                </Container>
            </Container>


        </>
    );
};
export default FakeNavBar;



